import { render, staticRenderFns } from "./BookingEvaluationCombinationComponent.vue?vue&type=template&id=13954b5c"
import script from "./BookingEvaluationCombinationComponent.vue?vue&type=script&lang=js"
export * from "./BookingEvaluationCombinationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports